import { render, staticRenderFns } from "./WitnessUsersListView.vue?vue&type=template&id=3990fc18&"
import script from "./WitnessUsersListView.vue?vue&type=script&lang=js&"
export * from "./WitnessUsersListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports